import { useAuthorization } from 'components/Authorization';
import { useLechatAgentEnable } from 'hooks/business/useOrgConfig';

export function hasAgentRoleAccess(roles: Oversea.Token.Payload['roles'] = []) {
  return roles.some(
    (role) =>
      role.name === 'SUPER_ADMIN' ||
      role.permissions.some((permission) => permission.name === 'SUPERVISE'),
  );
}

export function useAgentAccess() {
  const enabled = useLechatAgentEnable();
  const { payload } = useAuthorization<Oversea.Token.Payload>();
  return Boolean(enabled && hasAgentRoleAccess(payload?.roles));
}
